import { render } from "./YcomControl.vue?vue&type=template&id=30f18ec2&scoped=true"
import script from "./YcomControl.vue?vue&type=script&lang=js"
export * from "./YcomControl.vue?vue&type=script&lang=js"

import "./YcomControl.vue?vue&type=style&index=0&id=30f18ec2&scoped=true&lang=css"

import exportComponent from "D:\\A-daima\\前端\\前台\\前台\\nonferrous_metals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f18ec2"]])

export default __exports__